import { createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-5" }

import { computed, ref } from 'vue'

import WizardButton from '@/components/neue/wizard/WizardButton.vue'
import WizardConfirmModal from '@/components/neue/wizard/WizardConfirmModal.vue'
import { useConfirm } from '@/composables/useConfirm'
import { useToast } from '@/composables/useToast'
import privilegeService from '@/services/privilege.service'
import api from '@/store/api'


export default {
  __name: 'MembershipTierActions',
  props: {
  tierId: { type: String, required: true },
  tierName: { type: String, default: '' },
  tierType: { type: String, default: null },
  audienceId: { type: String, default: null }
},
  emits: ['deleted'],
  setup(__props, { emit: __emit }) {

const UNDELETABLE_TYPES = ['FreeMembershipTier', 'NoMembershipTier']

const props = __props

const emit = __emit
const { showToast } = useToast()

const { state: confirmState, ask, confirm: confirmYes, cancel: confirmNo } = useConfirm()

const tierLabel = computed(() => props.tierName.trim() || 'this membership')
const canReadCustomers = computed(() => privilegeService.canAccessResourceAction('customers', null, 'read'))
const canDelete = computed(() => privilegeService.canAccessResourceAction('sell', null, 'delete'))
const deletable = computed(
  () => canDelete.value && Boolean(props.tierType) && !UNDELETABLE_TYPES.includes(props.tierType)
)
const deleting = ref(false)

const deleteTier = async () => {
  const sure = await ask({
    title: `Delete ${tierLabel.value}?`,
    message: `${tierLabel.value} is removed from your membership tiers.`,
    confirmLabel: 'Delete',
    danger: true
  })
  if (!sure || deleting.value) return
  deleting.value = true
  try {
    await api.call('DELETE', `membership_tiers/${props.tierId}`)
    showToast('Membership tier deleted')
    emit('deleted')
  } catch {
    showToast('The membership tier could not be deleted.', { type: 'error' })
  } finally {
    deleting.value = false
  }
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.audienceId && canReadCustomers.value)
      ? (_openBlock(), _createBlock(WizardButton, {
          key: 0,
          to: `/lists/${__props.audienceId}`,
          class: "w-full"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" View customers ", -1)
          ]))]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    (deletable.value)
      ? (_openBlock(), _createBlock(WizardButton, {
          key: 1,
          variant: "danger",
          loading: deleting.value,
          onClick: deleteTier
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Delete " + _toDisplayString(tierLabel.value), 1)
          ]),
          _: 1
        }, 8, ["loading"]))
      : _createCommentVNode("", true),
    _createVNode(WizardConfirmModal, _mergeProps(_unref(confirmState), {
      onConfirm: _unref(confirmYes),
      onCancel: _unref(confirmNo)
    }), null, 16, ["onConfirm", "onCancel"])
  ]))
}
}

}